export const GET_DATA_REQUEST="GET_DATA_REQUEST"
export const GET_DATA_SUCCESS="GET_DATA_SUCCESS"
export const GET_DATA_FAIL="GET_DATA_FAIL"

export const GET_AGENCY_LIST_REQUEST="GET_AGENCY_LIST_REQUEST"
export const GET_AGENCY_LIST_SUCCESS="GET_AGENCY_LIST_SUCCESS"
export const GET_AGENCY_LIST_FAIL="GET_AGENCY_LIST_FAIL"
